import { styled } from "styled-components";

const ConsentActions = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }): string => theme.spacing[1.25]};
`;

export { ConsentActions };
